import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Zap, Users, Church, ArrowRight } from 'lucide-react';

const SolutionThemes = () => {
  const themes = [
    {
      icon: Church,
      title: 'Smart Temples',
      description: 'Preserving heritage through intelligent crowd monitoring, digital donation tracking, and automated lighting to enhance the devotee experience.',
      image: 'https://images.pexels.com/photos/326699/pexels-photo-326699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      link: '/smart-temple'
    },
    {
      icon: Building2,
      title: 'Smart Buildings',
      description: 'Integrating HVAC, security, and lighting into a single automated system to maximize occupant comfort and minimize energy waste.',
      image: 'https://images.unsplash.com/photo-1599580546666-c26f15e00933?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGJ1aWxkaW5nfGVufDB8fHx8MTc3MTcyODk4NHww&ixlib=rb-4.1.0&q=85',
      link: '/smart-building'
    },
    {
      icon: Zap,
      title: 'Smart Energy',
      description: 'Utilizing IoT-enabled grids and meters to monitor consumption in real-time, facilitating predictive maintenance and sustainable resource management.',
      image: 'https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxzb2xhciUyMGVuZXJneXxlbnwwfHx8fDE3NzE3Mjg5OTZ8MA&ixlib=rb-4.1.0&q=85',
      link: '/smart-energy'
    },
    {
      icon: Users,
      title: 'Smart Stadiums',
      description: 'Enhancing fan engagement and safety with high-density Wi-Fi, smart ticketing, and advanced video analytics for seamless crowd flow.',
      image: 'https://images.unsplash.com/photo-1766509191761-61710294e1a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzdGFkaXVtfGVufDB8fHx8MTc3MTcyODk4OXww&ixlib=rb-4.1.0&q=85',
      link: '/smart-stadium'
    }
  ];

  return (
    <section id="themes" className="themes-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Solution Themes</h2>
          <p className="section-description">
            Tailored smart solutions for diverse environments
          </p>
        </div>

        <div className="themes-grid">
          {themes.map((theme, index) => (
            <div key={index} className="theme-card">
              <div className="theme-image-wrapper">
                <img
                  src={theme.image}
                  alt={theme.title}
                  className="theme-image"
                />
                <div className="theme-overlay"></div>
                <div className="theme-icon-badge">
                  <theme.icon size={24} />
                </div>
              </div>
              <div className="theme-content">
                <h3 className="theme-title">{theme.title}</h3>
                <p className="theme-description">{theme.description}</p>
                <Link to={theme.link} className="theme-learn-more">
                  Learn More
                  <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionThemes;
